import type { OnDestroy } from '@angular/core';
import { effect, Injectable, signal } from '@angular/core';

import { EWebSocketMessage } from '@rpgc-ai/shared-interfaces/enums/websocket.enum';
import type { IVideoGenerationProgress, IVideoGenerationProgressMessage } from '@rpgc-ai/shared-interfaces/interfaces/websocket.interface';

import { WebsocketService } from '../websocket/websocket.service';

@Injectable({ providedIn: 'root' })
export class VideoGenerationProgressService extends WebsocketService<IVideoGenerationProgressMessage> implements OnDestroy {
  eventKey = EWebSocketMessage.VIDEO_GENERATION_PROGRESS;

  readonly #progressEntries = signal<Map<string, IVideoGenerationProgress>>(new Map());
  readonly progressMap = this.#progressEntries.asReadonly();

  constructor() {
    super();
    this.#trackProgressEffect();
  }

  removeProgress(messageVideoId: string): void {
    this.#progressEntries.update((prev) => {
      const next = new Map(prev);
      next.delete(messageVideoId);
      return next;
    });
  }

  clearAll(): void {
    this.#progressEntries.set(new Map());
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.#progressEntries.set(new Map());
  }

  #trackProgressEffect(): void {
    effect(() => {
      const event = this.message();
      if (!event) {
        return;
      }

      const data = event.data;
      if (!data.messageVideoId) {
        return;
      }

      const id = data.messageVideoId;

      // Don't remove on completed — let chat_video_inject handler clean up
      // to prevent visual gap between loader disappearing and video appearing
      this.#progressEntries.update((prev) => {
        const next = new Map(prev);
        next.set(id, data);
        return next;
      });
    });
  }
}
